import { createBasicSelector } from 'util/redux'
import { selectCurrentConversation } from './selectCurrentConversation'

export const selectCurrentTicketAssignedGroupId = createBasicSelector(
  selectCurrentConversation,
  ticket => ticket?.assigned?.team
)
